export * from './InfoPage'
